export { useDeviceType, DEVICE_TYPE, DeviceType } from './useDeviceType';
